export default __webpack_public_path__ + "static/media/arrow-right-button.e57c3e20.svg";